import React from 'react';
import Markdown, { type MarkdownToJSX } from 'markdown-to-jsx';

// Agent narration is conventional Markdown. Keep model-emitted HTML inert,
// render through a stable semantic wrapper so Volto's generic sidebar styles
// cannot mistake prose lists for control lists, and keep links from navigating
// away from an unsaved edit. optimizeForStreaming avoids rendering a dangling
// partial construct while a narration segment is still arriving.
const MARKDOWN_OPTIONS: MarkdownToJSX.Options = {
  disableParsingRawHTML: true,
  forceBlock: true,
  forceWrapper: true,
  optimizeForStreaming: true,
  wrapper: 'div',
  wrapperProps: { className: 'assistant-markdown' } as Record<string, unknown>,
  overrides: {
    a: { props: { target: '_blank', rel: 'noopener noreferrer' } },
  },
};

interface AssistantMarkdownProps {
  children: string;
  /** A turn still arriving: the caret rides the last line. */
  streaming?: boolean;
}

const AssistantMarkdown = ({
  children,
  streaming = false,
}: AssistantMarkdownProps) => (
  <div className={`assistant-message-content${streaming ? ' streaming' : ''}`}>
    <Markdown options={MARKDOWN_OPTIONS}>{children}</Markdown>
  </div>
);

export default AssistantMarkdown;
